<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="bg">
    <div class="bg-container">
      <div class="container" style="background: #fff;">

        <div class="content">
          <div class="headline">
            <p class="headTit">服务内容</p>
          </div>
          <div class="wp750">
            <ul class="introduce">
              <li>
                <div class="icon01">                
                  <span class="tit">求购信息</span>
                  <span class="con">买家通过平台发布求购信息</span>
                </div>
              </li>
              <li>
                <div class="icon02">                
                  <span class="tit">货源信息</span>
                  <span class="con">提供全面购买渠道货源信息</span>
                </div>
              </li>
              <li>
                <div class="icon03">                
                  <span class="tit">更多优选</span>
                  <span class="con">货主通过平台发布货源信息</span>
                </div>
              </li>
              <li>
                <div class="icon04">                
                  <span class="tit">安全交易</span>
                  <span class="con">第三方安全支付保障</span>
                </div>
              </li>
              <li>
                <div class="icon05">                
                  <span class="tit">今日报价</span>
                  <span class="con">主要口岸各类木材实时报价</span>
                </div>
              </li>
              <li>
                <div class="icon06">                
                  <span class="tit">金融服务</span>
                  <span class="con">仓单质押、进口开证、信用贷款</span>
                </div>
              </li>
              <div class="clear"></div>
            </ul>
          </div>
        </div>
      </div>

      <div class="container" id="second">
        <div class="content">
          <div class="content-container">

            <div class="headline">
              <p class="headTit">APP预览图</p>
            </div>

            <div class="img">
              <div class="row">
                <div class="col-md-16">
                  <img src="/static/img/app/preview.png" width="80%" height="80%" style="margin:0 auto;display:block;">
                </div>
               <!--  <div class="col-md-1">
                  <img src="/static/img/app/app1.jpg" width="100%" height="100%"/>
                </div>
                <div class="col-md-3">
                  <img src="/static/img/app/app2.jpg" width="100%" height="100%"/>
                </div>
                <div class="col-md-3">
                  <img src="/static/img/app/app3.png" width="100%" height="100%"/>
                </div>
                <div class="col-md-3">
                  <img src="/static/img/app/app4.png" width="100%" height="100%"/>
                </div> -->
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="container" style="background:#fff;">
        <div class="content">
          <div class="headline">
            <p class="head">
              <img src="static/img/app/logo.png" width="250" height="78">
            </p>
            <p class="head">下载渠道</p>
            <p class="platform dividingLine"></p>
          </div>
          <div class="flexiable">
            <div class="downloadios">
              <li>
                <span>iphone版</span>
                <div class="clear"></div>
              </li>
              <p>通过苹果手机应用商店</p>
              <p>App Store搜索“木材码头”</p>
            </div>
            <div class="downloadna">
              <li>
                <span>安卓市场</span>
                <div class="clear"></div>
              </li>
              <p>支持：华为、腾讯、小米、360、</p>
              <p>百度、安卓、安智、91助手、豌</p>
              <p>豆荚等应用市场。</p>
            </div>
            <div class="clear"></div>
          </div>
          <div class="flexiable">
            <div class="mar980">
              <a href="http://app.emulian.com/" class="downloadBtn">立即下载</a>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  export default {
    name: 'homeAppContent',
    props: ['isSecond', 'title', 'desc', 'isLeft']
  }
</script>
<style scoped>
.mart42{
  margin-top: 42px;
}
.mar980{
  width: 980px;
  margin: 60px auto 0;
  padding-bottom: 60px;
}
.mart40{
  margin-top: 40px;
}
ul,li{
    list-style-type:none;
}
  div.bg {
    display: flex;
  }

  div.bg-container {
    padding: 0;
    /*width: 1100px;*/
    width: 100%;
    height: auto;
    margin: auto;
    background-color: rgb(242, 242, 242);
  }

  div.container {
    padding: 0;
    margin: 0;
    width: inherit;
  }

  div#second {
    background-color: rgb(215, 215, 215);
  }

  div.content-container {
    width: auto;
  }

  div.content {
    width: auto;
    padding: 0;
    height: auto;
    margin-left: 14%;
    margin-right: 14%;
    margin-top: 5%;
    /*margin-bottom: 5%;*/
  }

  div.content .wp750{
    width: 750px;
    margin: 0 auto;
  }
  div.content .wp750 .introduce{
    width: 100%;
    background: url('/static/img/app/overlapPic.png') no-repeat bottom center;
    background-size: 450px 350px;
    padding-bottom: 340px;
  }
  div.content .wp750 .introduce li{
    margin-top: 40px;
    width: 50%;
    float: left;
  }
  div.content .wp750 .introduce li div{
    padding-left: 54px;
  }
  div.content .wp750 .introduce li div.icon01{
    background: url('/static/img/app/icon01.png') no-repeat left top;
    background-size: 46px 46px;
  }
  div.content .wp750 .introduce li div.icon02{
    background: url('/static/img/app/icon02.png') no-repeat left top;
    background-size: 46px 46px;
  }
  div.content .wp750 .introduce li div.icon03{
    background: url('/static/img/app/icon03.png') no-repeat left top;
    background-size: 46px 46px;
  }
  div.content .wp750 .introduce li div.icon04{
    background: url('/static/img/app/icon04.png') no-repeat left top;
    background-size: 46px 46px;
  }
  div.content .wp750 .introduce li div.icon05{
    background: url('/static/img/app/icon05.png') no-repeat left top;
    background-size: 46px 46px;
  }
  div.content .wp750 .introduce li div.icon06{
    background: url('/static/img/app/icon06.png') no-repeat left top;
    background-size: 46px 46px;
  }
  div.content .wp750 .introduce li div span{
    width: 100%;
    display: block;
  }
  div.content .wp750 .introduce li div span.tit{
    font-size: 24px;
  }
  div.content .wp750 .introduce li div span.con{
    font-size: 16px;
  }
  div.img {
    margin-top: 5%;
    margin-bottom: 5%;
  }

  div.col-md-6 {
    padding: 0;
  }

  div.col-md-4 {

  }

  div.row {
    margin-top: 2%;
  }

  div.text {
    margin-top: 20px;
  }

  div.headline {
    font-weight: 700;
    font-size: 24px;
    font-family: 'PingFangSC-Semibold', "PingFang SC Semibold", "PingFang SC";
    font-style: normal;
  }

  p.headTit {
    text-align: center;
    width: inherit;
    /*background: url('/static/img/app/logo.png') no-repeat top center;*/
    background-size: 287px 89px;
    font-size: 32px;
    font-weight: normal;
  }

  p.headTit span{
    height: 36px;
    border-bottom: 1px solid #e2e2e2;
  }
  p.head {
    text-align: center;
    width: inherit;
    margin-top: 20px;
    /*background: url('/static/img/app/logo.png') no-repeat top center;*/
    background-size: 287px 89px;
    font-size: 32px;
    font-weight: normal;
  }
  div.label {
    font-family: 'Helvetica-Bold', "Helvetica Bold", Helvetica;
    font-weight: 700;
    font-style: normal;
    font-size: 16px;
    color: #333333;
    padding: 0;
    margin: 0;
  }

  div.description {
    width: auto;
    color: #999999;
    font-weight: 400;
    font-size: 13px;
    font-family: 'Helvetica', 'Helvetica';
    white-space: nowrap;
    text-align: left;
    padding: 0;
    margin: 0;
    margin-top: 20px;
  }

  p {
    padding: 0;
    margin: auto;
    width: inherit;
    white-space: pre-line;
    text-align: left;
  }

  .platform {
    background: url('/static/img/app/dividingLine.png') no-repeat center center;
    background-size: 80%;
    font-size: 18px;
    color: #999999;
    width: 100%;
    height: 50px;
    text-align: center;
    line-height: 30px;
    font-weight: 400;
  }

  .ios-origin {
    display: flex;
    margin: auto;
    border-bottom: solid;
    border-width: 1px;
    padding-left: 30px;
    padding-right: 30px;
  }

  .item {
    color: #333333;
    font-size: 14px;
    font-family: 'Arial-BoldMT', 'Arial Bold', 'Arial';
    font-weight: 700;
    font-style: normal;
    float: left;
    margin: 10px;
  }

  .icon {
    width: 20px;
    height: 20px;
  }

  .icon-rect {
    width: 64px;
    height: 20px;
  }

  .flexiable {
    display: block;
  }
  .flexiable .downloadios{
    width: 50%;
    float: left;
  }
  .flexiable .downloadna{
    width: 50%;
    float: left;
  }
  .flexiable .downloadna li{
    width: 100%;
    text-align: center;
    padding-bottom: 20px;
  }
  .flexiable .downloadios li{
    width: 100%;
    text-align: center;
    padding-bottom: 20px;
  }
  .flexiable .downloadios li span{
    float: right;
    padding-left: 80px;
    margin-right: 40px;
    height: 114px;
    line-height: 114px;
    color: #606060;
    font-size: 32px;
    background: url('/static/img/app/iphoneDownload.png') no-repeat left center;
    background-size: 58px 65px;
  }
  .flexiable .downloadna li span{
    float: left;
    margin-left: 90px;
    padding-left: 80px;
    height: 114px;
    line-height: 114px;
    color: #606060;
    font-size: 32px;
    background: url('/static/img/app/naDownload.png') no-repeat left center;
    background-size: 63px 67px;
  }
  .flexiable .downloadna p{
    width: 360px;
    margin-left: 80px;
    height: 36px;
    line-height: 36px;
    font-size: 16px;
  }
  .flexiable .downloadios p{
    width: 360px;
    margin-left: 180px;
    height: 48px;
    line-height: 48px;
    font-size: 16px;
  }
  .android-origin {
    display: flex;
    margin: auto;
    padding-left: 30px;
    padding-right: 30px;
  }

  .platform {
    margin-top: 2%;
    margin-bottom: 2%;
  }
  .downloadBtn{
    margin: 0 auto;
    width: 196px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    font-size: 26px;
    font-weight: bold;
    color: #fff;
    background: #2f9c3b;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// HomeAppContent.vue?003f3a70